import websitePage from 'hoc/websitePage/websitePage';

import ErrorPage from '../screens/404/404';

export default websitePage(ErrorPage, {
  routeKey: '404',
  allowApplicationForm: false,
});
